var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zen-search',{attrs:{"type":"number","step":"1","value":_vm.value ? _vm.value : '',"placeholder":_vm.placeholder,"disabled":_vm.disabled,"hide-search-icon":true},on:{"update":function($event){return _vm.update($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }